import { render, staticRenderFns } from "./ResetIndex.vue?vue&type=template&id=312af03d&scoped=true&"
import script from "./ResetIndex.vue?vue&type=script&lang=js&"
export * from "./ResetIndex.vue?vue&type=script&lang=js&"
import style0 from "./ResetIndex.vue?vue&type=style&index=0&id=312af03d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "312af03d",
  null
  
)

export default component.exports